import React from "react";

type StopsValue = "none" | "one-or-fewer" | "one" | "two" | "three" | null;

interface StopsFilterProps {
  stopsFilter: StopsValue;
  onStopsFilterChange: (filter: StopsValue) => void;
  displayedResultCount: number;
  hideInternalFilters?: boolean;
  hideConnectedFilter?: boolean;
}

const OPTIONS: {
  value: Exclude<StopsValue, null>;
  label: string;
  connectedOnly?: boolean;
}[] = [
  { value: "none", label: "Non-stop" },
  { value: "one", label: "1 Stop" },
  { value: "two", label: "2 Stops" },
  { value: "three", label: "3 Stops" },
  { value: "one-or-fewer", label: "Connected", connectedOnly: true },
];

const StopsFilter: React.FC<StopsFilterProps> = ({
  stopsFilter,
  onStopsFilterChange,
  displayedResultCount,
  hideInternalFilters = false,
  hideConnectedFilter = false,
}) => (
  <div
    className={`w-[200px] flex-shrink-0 ${hideInternalFilters ? "hidden" : "hidden md:block"}`}
  >
    <div className="sticky top-4">
      <div className="flex items-center justify-between mb-1">
        <p className="text-[#1F2937] text-base font-bold">Filters</p>
        <button
          type="button"
          className="text-[#9CA3AF] hover:text-[#6B7280] transition-colors"
          title="Reset filters"
          onClick={() => onStopsFilterChange("none")}
        >
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
            />
          </svg>
        </button>
      </div>
      <p className="text-[#6B7280] text-xs mb-5">
        Showing {displayedResultCount} results
      </p>

      <div className="mb-2">
        <p className="text-[#1F2937] text-sm font-semibold mb-3">Stops</p>
        <div className="flex flex-col gap-3">
          {OPTIONS.filter(
            (o) => !(o.connectedOnly && hideConnectedFilter),
          ).map((o) => (
            <label
              key={o.value}
              className="flex items-center justify-between cursor-pointer group"
            >
              <div className="flex items-center gap-2">
                <input
                  type="radio"
                  name="stops"
                  checked={stopsFilter === o.value}
                  onChange={() => onStopsFilterChange(o.value)}
                  className="w-4 h-4 text-[#FBBF24] border-gray-300 focus:ring-[#FBBF24] accent-[#1F2937]"
                />
                <span className="text-sm text-[#4B5563] group-hover:text-[#1F2937]">
                  {o.label}
                </span>
              </div>
            </label>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default StopsFilter;
